import "./MecredCommingSoon.scss";

const MecredCommingSoon = () => {
    return(
        <section className="mecred_soon">
            <div className="content_wrap p_t p_b">
                <h2>MeCred (DIFC) Ltd is under formation.</h2>
            </div>
        </section>
    )
}

export default MecredCommingSoon;